export enum OskCoursePaymentType {
    OneTime = 0,
    Installments = 1,
}
